import { getUserName } from "../../../app/auth.js";
import { applySheets } from "../../../app/utils/styleCache.js";
import { openDialog } from "../../features/app-dialog/utils/core/dialogManager.js";
import { onStateChange, isDialogActive } from "../../../app/activeStateManager.js";

export class AppHeader extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.isMounted = false;
        this.unsubscribe = null;
    }

    connectedCallback() {
        this.render();

        this.isMounted = true;

        this.setupEventListeners();

        const nameElement = this.shadowRoot.getElementById('username');
        if (nameElement) nameElement.textContent = getUserName() ?? '...';

        const logo = this.shadowRoot.querySelector('.logo');
        const logoPromise = new Promise(resolve => {
            if (logo.complete) resolve();
            else {
                logo.addEventListener('load', resolve);
                logo.addEventListener('error', resolve);
            }
        });

        Promise.all([
            logoPromise,
            applySheets(this.shadowRoot, [
                "components/layout/app-header/app-header.css",
                "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css",
            ]),
        ]).then(() => requestAnimationFrame(() => {
            this.shadowRoot.querySelector('header')?.classList.add('loaded');
            this.unsubscribe = onStateChange(() => this.updateUserBoxState());
            this.setAttribute('loaded', '');
        }));
    }

    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
    }

    updateUserBoxState() {
        const userBox = this.shadowRoot.getElementById('userBox');
        if (userBox) {
            userBox.classList.toggle('active', isDialogActive('user'));
        }
    }

    render() {
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    opacity: 0;
                    transition: opacity 0.4s ease;
                }
                :host([loaded]) { opacity: 1 }

                header {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    height: 30px;
                    padding: 10px;
                    box-sizing: content-box;
                }

                .headerLeft, .userBox {
                    opacity: 0;
                    transition: opacity 0.5s ease;
                }
                header.loaded .headerLeft,
                header.loaded .userBox {opacity: 1}
            </style>

            <header>
                <div class="headerLeft">
                    <img slot="logo" class="logo" src="assets/icons/cedura.png"/>
                    <p class="title">${typeof __APP_ENV__ !== "undefined" && __APP_ENV__ === "qa" ? "QA Cedura Desk" : "Cedura Desk"}</p>
                </div>
                <div class="breadcrumb" id="breadcrumb"></div>
                <slot name="headerright">
                    <div class="userBox" id="userBox">
                        <p class="username" id="username">...</p>
                        <i class="fa-solid fa-user userIcon"></i>
                    </div>
                </slot>
            </header>
        `;
    }

    setPageTitle(name) {
        const element = this.shadowRoot.getElementById('breadcrumb');
        if (element) element.textContent = name;
    }

    setupEventListeners() {
        const userBox = this.shadowRoot.getElementById('userBox');
        if (userBox) userBox.addEventListener('click', () => openDialog('user'));
    }
}

customElements.define("app-header", AppHeader);